import { render } from "./Mb014.vue?vue&type=template&id=1a789497"
import script from "./Mb014.vue?vue&type=script&lang=js"
export * from "./Mb014.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__